import { apiV3Typed } from 'Services/api/apiV3';
import { getUserCookieKey } from 'Services/api/utils';

type ParamsT = {
  userId?: string;
  page?: number;
  size?: number;
  userBioTags?: boolean;
  userIds?: ReadonlyArray<string>;
  contributor?: boolean;
};

const DEFAULT_AUTHORS_IN_REQUEST = 20;

export const getFollowingAuthors = async ({
  userId,
  userIds,
  page = 1,
  size = DEFAULT_AUTHORS_IN_REQUEST,
  userBioTags = false,
  contributor = false,
}: ParamsT = {}) => {
  const params: Record<string, any> = {
    filter: {},
  };

  if (userId) {
    params.filter.user_id = userId;
  }

  if (userIds) {
    params.filter.user_ids = userIds.join(',');
  }

  if (contributor) {
    params.filter.contributor = true;
  }

  const include = ['author'];

  if (userBioTags) {
    include.push('userBioTags');
  }

  const response = await apiV3Typed.get('account/{cookie_key}/followings', {
    path: {
      cookie_key: getUserCookieKey(),
    },
    query: {
      include: include.join(','),
      // @ts-expect-error [API Types]
      page: {
        size: String(size),
        number: String(page),
      },
      ...params,
    },
  });

  return response;
};
